import {useMemo} from 'react'

import type {Person} from '@pleo-io/deimos'
import type {AvatarProps} from '@pleo-io/telescope'
import {Avatar} from '@pleo-io/telescope'
import {Wallet} from '@pleo-io/telescope-icons'

import type {UserData} from '~/shell/user'

export const getName = (employee?: Partial<Person>) => {
    if (!employee) {
        return '?'
    }

    const initials = [(employee.firstName || '')[0], (employee.lastName || '')[0]]
        .join('')
        .toUpperCase()

    if (initials) {
        return `${employee?.firstName || ''} ${employee?.lastName || ''}`
    }

    return employee.email || '?'
}

type AvatarEmployeeProps = AvatarProps &
    Partial<Pick<UserData, 'role'>> & {employee?: Partial<Person>}

export const AvatarEmployee = ({employee, role, ...props}: AvatarEmployeeProps) => {
    const isBookkeeper = useMemo(() => role && role.startsWith('bookkeeper'), [role])

    return (
        <Avatar
            name={getName(employee)}
            src={employee?.avatar?.url}
            icon={isBookkeeper ? <Wallet /> : undefined}
            {...props}
        />
    )
}
